var _rect, _rect2, _text, _line, _line2, _line3, _line4, _line5, _line6, _line7, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcnShipmentList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 52,
    height: 48,
    rx: 4,
    fill: "#f0f7ff",
    stroke: "#2977ff",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 52,
    height: 12,
    rx: 4,
    fill: "#2977ff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 16,
    textAnchor: "middle",
    fill: "white",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: "bold"
  }, "MCN")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 26,
    x2: 52,
    y2: 26,
    stroke: "#2977ff",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 30,
    x2: 48,
    y2: 30,
    stroke: "#2977ff",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 34,
    x2: 50,
    y2: 34,
    stroke: "#2977ff",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 38,
    x2: 46,
    y2: 38,
    stroke: "#2977ff",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 42,
    x2: 49,
    y2: 42,
    stroke: "#2977ff",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 46,
    x2: 47,
    y2: 46,
    stroke: "#2977ff",
    strokeWidth: 1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 50,
    x2: 51,
    y2: 50,
    stroke: "#2977ff",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#ff9500"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#ff9500"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 32,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#ff9500"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 36,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#ff9500"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 40,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#ff9500"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 44,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#ff9500"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 48,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#ff9500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46, 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 4,
    width: 12,
    height: 6,
    rx: 1,
    fill: "#34c759"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 6,
    width: 8,
    height: 2,
    fill: "#30a751"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12,
    r: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 2,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 12,
    r: 1,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 12,
    r: 1,
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 28,
    r: 2,
    fill: "#34c759"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 34,
    r: 2,
    fill: "#ff9500"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 40,
    r: 2,
    fill: "#ff3b30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcnShipmentList);
export default __webpack_public_path__ + "static/media/mcnShipmentList.d7cce5ad763cc92fc04a8cb87559e11e.svg";
export { ForwardRef as ReactComponent };